module.exports = __webpack_public_path__ + "static/media/news-img05.3b883367.jpg";